export const PAPER_SCRIPT = 3

export const E_SCRIPT = 1